/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CompEvent} from "../../models/CompEvent";
import {Subscription} from "rxjs";
import {EventService} from "../../providers/event-service";
import {CompetitionService} from "../../providers/competition-service";
import {NavController} from "ionic-angular";
import {EventSchedulePage} from "../../pages/event-schedule-page/event-schedule-page";

/**
 * Generated class for the EventItem component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'event-item',
  templateUrl: 'event-item.html'
})
export class EventItem implements OnInit, OnDestroy {

  @Input()
  event: CompEvent;

  @Input()
  isPurchased: boolean;

  @Input()
  showCompetition: boolean = true;

  @Output()
  eventSelect: EventEmitter<CompEvent> = new EventEmitter();

  @Output()
  restoreSelect: EventEmitter<CompEvent> = new EventEmitter<CompEvent>();

  constructor(private eventService: EventService,
              private compService: CompetitionService,
              private navController: NavController) {

    console.log('Hello EventItem Component');
  }

  selectEvent() {
    this.eventSelect.next(this.event);
  }

  ngOnInit(): void {
    // get competition
    this.compService.getCompetitionById(this.event.competition.id).then(comp => {
      this.event.competition = comp;
    });

    this.eventService.getVenueById(this.event.venue.id).then(venue => {
      this.event.venue = venue;
    });
  }

  ngOnDestroy(): void {

  }

  restorePurchase() {
    this.restoreSelect.next(this.event);
  }
}



// WEBPACK FOOTER //
// ./src/components/event-item/event-item.ts